
import Vue from 'vue'
import {State} from 'vuex-class'
import Component from 'vue-class-component'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import GroupService from '@/services/GroupService'
import GridHeader from '@/models/gridHeader'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import {Group, GroupStatus} from '../../models/group'
import {User as Storeuser} from '../../store/index'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import { Assignment, AssignmentPerType } from '@/models/assignments'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    CardTitle,
    ProgressLinear,
  },
})
export default class GroupDetails extends Vue {
  @Prop(Function) public readonly fetchAssignements!: (groupId: number) => AssignmentPerType
  @Prop(Function) public readonly onClose!: () => void
  @State private user!: Storeuser
  private isLoading: boolean = false
  private headers: GridHeader[] = []
  private searchValue: string = ''
  private tab: any = null
  private group: Group
  private groupStatus: GroupStatus[] = []
  private groupAssignements: AssignmentPerType
  private dialog: boolean = false
  private errorHandlerService: ErrorHandlerService

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  public async show(group: Group) {
    this.group = group
    this.isLoading = true
    this.dialog = true
    const groupAssignments = await this.fetchAssignements(group.groupe_ad_id)
    if (groupAssignments !== undefined) {
      group.assignments = groupAssignments
    }
    await this.fetchGroupDetails()
    this.isLoading = false
  }

  private mounted() {
    this.createHeaders()
  }

  private closeDialog() {
    this.tab = null
    this.dialog = false
  }

  private async fetchGroupDetails() {
      try {
        const response = await GroupService.fetchGroupStatus(this.group.groupe_ad_id)
        this.groupStatus = response.groupsStatus
        this.groupAssignements = response.assignments
      } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      }
  }

private createHeaders() {
  this.headers.push(new GridHeader(this.$t('Establishment').toString(), 'etablissement_id', 'left', true, 200))
  this.headers.push(new GridHeader(this.$t('AD').toString(), 'is_in_ad', 'center', true, 50))
  this.headers.push(new GridHeader(this.$t('EtatAD').toString(), 'etat_ad', 'center', true, 50))
  this.headers.push(new GridHeader(this.$t('EtatRefedu').toString(), 'etat_refedu', 'left', true, 50))
}

private getSchoolName(schoolId: number) {
  const school = this.user.schools.find(( sc ) => sc.etablissement_id === schoolId)
  const schoolName = school === undefined ? schoolId : school.nom
  return schoolName
}

private parseAssignments(key: string, assignment: Assignment[]) {
  let formattedSring = ''
  if (assignment.length !== 0) {
    const values = assignment.map((v) => v.name).join(', ')
    formattedSring += `${key}: ${values}, `
  } else {
    formattedSring += `${key}: , `
  }
  return formattedSring
}

}
